import { render, staticRenderFns } from "./gc-record.vue?vue&type=template&id=d79c8780&scoped=true&"
import script from "./gc-record.vue?vue&type=script&lang=js&"
export * from "./gc-record.vue?vue&type=script&lang=js&"
import style0 from "./gc-record.vue?vue&type=style&index=0&id=d79c8780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79c8780",
  null
  
)

export default component.exports